import React from 'react';
import { COLOR_MAP } from 'common/colors';

const ApiIcon: React.FC<{ height?: string; width?: string }> = ({
  height = 32,
  width = 40,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V32C36 34.2091 34.2091 36 32 36H4C1.79086 36 0 34.2091 0 32V4Z"
        fill={COLOR_MAP.NEW_BLUE_PURPLE}
      />
      <path
        d="M11.665 21.5703L12.2046 23.5H14.0835L11.1128 14.2578H9.49414L6.46631 23.5H8.34521L8.89111 21.5703H11.665ZM9.3291 20.0532L10.3003 16.6509L11.2461 20.0532H9.3291ZM16.8257 20.1104H18.2031C18.7067 20.1104 19.1616 20.0384 19.5679 19.8945C19.9741 19.7507 20.3211 19.5496 20.6089 19.2915C20.8924 19.0376 21.1104 18.735 21.2627 18.3838C21.4193 18.0326 21.4976 17.6496 21.4976 17.2349C21.4976 16.7905 21.4193 16.3864 21.2627 16.0225C21.1104 15.6585 20.8924 15.3454 20.6089 15.083C20.3211 14.8249 19.9741 14.6239 19.5679 14.48C19.1616 14.3319 18.7067 14.2578 18.2031 14.2578H15.042V23.5H16.8257V20.1104ZM16.8257 18.6631V15.7051H18.2031C18.457 15.7051 18.6771 15.7453 18.8633 15.8257C19.0495 15.9061 19.2061 16.0161 19.333 16.1558C19.4557 16.2954 19.5467 16.4583 19.606 16.6445C19.6694 16.8307 19.7012 17.0317 19.7012 17.2476C19.7012 17.4338 19.6694 17.6136 19.606 17.7871C19.5467 17.9564 19.4557 18.1066 19.333 18.2378C19.2061 18.369 19.0495 18.4727 18.8633 18.5488C18.6771 18.625 18.457 18.6631 18.2031 18.6631H16.8257ZM23.1289 14.2578V15.6987H24.8872V22.0654H23.1289V23.5H28.4736V22.0654H26.6709V15.6987H28.4736V14.2578H23.1289Z"
        fill="white"
      />
    </svg>
  );
};

export default ApiIcon;
